import React from "react"
import ReactSVG from "react-svg"
import EarnedMilesLogo from "../../../images/rewards/earned-miles.svg"
import { Image } from "semantic-ui-react"
import { withTranslation } from "react-i18next"
import RewardDefaultLogo from "../../../images/rewards/reward_default_logo.png"
import { numberFormater } from "../../../v1/helpers/cuvrdHelpers"

const EarnedMiles = ({ earnedMiles, t }) => {
  return (
    <div className="earned-miles-container">
      <Image src={earnedMiles.image || RewardDefaultLogo} className="earned-miles-image" />
      <ReactSVG src={EarnedMilesLogo} className="earned-miles-complete" />
      <p className="earned-miles-data">
        {earnedMiles.miles ? numberFormater(earnedMiles.miles) : 0} {t("miles")}
      </p>
      <p className="earned-miles-service">{earnedMiles.name}</p>
    </div>
  )
}

export default withTranslation("rewards")(EarnedMiles)
